// extracted by mini-css-extract-plugin
module.exports = {"landing_page_O":"O_landing_page_O__iCxb5"};